__turbopack_context__.v({
  "container": "_75QcaG_container" + " " + __turbopack_context__.i(576919)["container"],
  "popularContainer": "_75QcaG_popularContainer",
  "popularPillsContainer": "_75QcaG_popularPillsContainer",
  "popularTitle": "_75QcaG_popularTitle",
});
